<amplify-authenticator [loginMechanisms]="['email']" [hideSignUp]="true">
  <ng-template amplifySlot="sign-in-header">
    <h2 class="amplify-heading aanmelden">
      Aanmelden in Zorg&#64;HOME
    </h2>
  </ng-template>

  <ng-template amplifySlot="forgot-password-header">
    <h2 class="amplify-heading">
      Herstel je wachtwoord
    </h2>
  </ng-template>

  <ng-template amplifySlot="confirm-reset-password-header">
    <h2 class="amplify-heading">
      Herstel je wachtwoord
    </h2>
  </ng-template>

  <ng-template amplifySlot="force-new-password-header">
    <h2 class="amplify-heading">
      Wachtwoord veranderen
    </h2>
  </ng-template>
</amplify-authenticator>
